import React, { ChangeEvent, useState } from 'react'
import {
  CButton,
  CFormInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import { getExchangerTransfer } from '../../details/model'
import { submitRollback } from './model'
import { useStore } from 'effector-react'

type Props = {
  id: string
  isVisible: boolean
  onClose: () => void
}
export const RollbackModal: React.FC<Props> = ({ id, isVisible, onClose }) => {
  const [reason, setReason] = useState('')
  const isLoading = useStore(getExchangerTransfer.pending)

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const value = event.currentTarget.value
    setReason(value)
  }

  return (
    <CModal visible={isVisible} onClose={onClose} size={'lg'}>
      <CModalHeader>
        <CModalTitle>Rollback modal</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CFormInput
          id="rollbackReason"
          name="rollbackReason"
          label="Rollback reason"
          value={reason}
          onChange={handleChange}
        />
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cancel
        </CButton>
        <CButton
          color="primary"
          className="px-4"
          type="submit"
          onClick={() => {
            submitRollback({
              requestId: id,
              rollbackReason: reason,
            })
            onClose()
          }}
          disabled={isLoading}
        >
          {isLoading && (
            <span className="spinner-border spinner-border-sm"></span>
          )}
          Ok
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
